import axios from 'axios'

const API = process.env.VUE_APP_API;

let visibilityHandler = null;

export const state = {
    userSettings: null,
    showSettingsModal: false,
};

export const getters = {
    mobileFeedNotifications(state) {
        return state.userSettings ? state.userSettings.mobile_feed_notifications : true;
    },

    // Edit-meal modal preferences; defaults apply until settings load.
    mealStepperLegacy(state) {
        return state.userSettings ? !!state.userSettings.meal_stepper_legacy : false;
    },

    foodListMacros(state) {
        return state.userSettings ? state.userSettings.food_list_macros !== false : true;
    },

    foodSearchAllLists(state) {
        return state.userSettings ? state.userSettings.food_search_all_lists !== false : true;
    },

    clientFileUploads(state) {
        return state.userSettings ? state.userSettings.client_file_uploads !== false : true;
    },
};

export const mutations = {
    SET_USER_SETTINGS(state, settings) {
        state.userSettings = settings;
    },
    SET_SHOW_SETTINGS_MODAL(state, value) {
        state.showSettingsModal = value;
    },
};

export const actions = {
    init({ dispatch, rootGetters }) {
        if (rootGetters['auth/loggedIn']) {
            dispatch('startTabSyncListener');
        }
    },

    startTabSyncListener({ dispatch, rootGetters }) {
        if (visibilityHandler) return;

        visibilityHandler = () => {
            if (document.visibilityState === 'visible' && rootGetters['auth/loggedIn']) {
                dispatch('fetchSettings');
            }
        };
        document.addEventListener('visibilitychange', visibilityHandler);
    },

    stopTabSyncListener() {
        if (visibilityHandler) {
            document.removeEventListener('visibilitychange', visibilityHandler);
            visibilityHandler = null;
        }
    },

    fetchSettings({ commit, dispatch }) {
        return axios.get(`${API}/users/settings`).then(res => {
            commit('SET_USER_SETTINGS', res.data.settings);
            dispatch('dietPlan/syncAppearance', res.data.settings, { root: true });
            return res.data.settings;
        }).catch(() => {});
    },

    updateSettings({ commit }, payload) {
        return axios.put(`${API}/users/settings`, payload).then(res => {
            commit('SET_USER_SETTINGS', res.data.settings);
            return res.data.settings;
        });
    },

    openSettingsModal({ commit }) {
        commit('SET_SHOW_SETTINGS_MODAL', true);
    },

    closeSettingsModal({ commit }) {
        commit('SET_SHOW_SETTINGS_MODAL', false);
    },

    reset({ commit, dispatch }) {
        dispatch('stopTabSyncListener');
        commit('SET_USER_SETTINGS', null);
        commit('SET_SHOW_SETTINGS_MODAL', false);
    },
};
